Vue.asyncComponent('cms-dashboard-spine-version', {
    props: {
        version: {
            type: String,
            default: '-',
        },
        releaseDate: {
            type: String,
            default: '-',
        },
        age: {
            type: String,
            default: '-',
        },
        isOutdated: {
            type: Boolean,
            default: false,
        },
        updateNotice: {
            type: String,
            default: '',
        },
    },
}, 'cms/dashboard/live/cms-dashboard-spine-version.html');
